// extracted by mini-css-extract-plugin
export default {"modal":"SaveWarningModal_modal__8oGd8","modal__footer":"SaveWarningModal_modal__footer__+Azur"};